document.addEventListener("alpine:init", () => {
  Alpine.data("product", (data) => ({
    selectedVariantID: data.variantID,
    isCustom: false,
    customFields: {
      width: {
        id: null,
        value: null,
      },
      length: {
        id: null,
        value: null,
      },
      shape: {
        id: null,
        value: null,
      },
    },
    isMain: data.isMain,
    quantity: 1,
    currentImageIndex: 0,
    showImageOverlay: false,
    imageOvelayIndex: "",
    addToCartLoading: false,
    showShowroomOverlay: false,
    variants: data.variants ? JSON.parse(data.variants) : [],
    stockTracking: data.stockTracking,
    deliveryTimeLoading: true,
    deliveryTime: {
      inStock: "",
      DeliveryDateInText: "",
    },
    deliveryTimeError: false,
    init() {
      if (data.isMain) {
        this.$nextTick(() => {
          const params = new URL(window.location.href).searchParams;
          if (params.get("scrollPos")) {
            window.scrollBy(0, Number(params.get("scrollPos")));
          }
        });
      }
      this.$watch("selectedVariantID", () => {
        if (this.isMain) {
          window.location.href = this.constructUrl();
        }
      });
    },
    showBackInStockMailer() {
      const url = new URL(window.location.href);
      let excludeList = [
        1172667, 1127096, 339461, 1221625, 1139718, 1189029, 927539, 339473,
        995761, 840073, 1229765, 845389, 1270836, 1245889, 339470, 1204412,
        759506, 1265614, 1007925, 1126583, 1104362, 635042, 1284265, 1285116,
      ];
      if (
        url.hostname === "www.volero.de" ||
        url.hostname === "volero.de" ||
        url.hostname === "staging-de.volero.nl"
      ) {
        excludeList = [
          1284317, 1268260, 1258663, 1257359, 1245032, 1245028, 1245026,
          1245024, 1245018, 1244862, 1081212, 1195740, 1077664, 902643,
        ];
      }
      if (!data.supplier) {
        return false;
      }
      if (excludeList.includes(data.supplier)) {
        return false;
      }
      return true;
    },
    showOutOfStockButton() {
      if (this.deliveryTimeLoading) {
        this.$dispatch("show-out-of-stock-button", false);
        return false;
      }
      if (
        this.selectedVariantID &&
        this.stockTracking === "enabled" &&
        !this.deliveryTime.inStock
      ) {
        this.$dispatch("show-out-of-stock-button", true);
        return true;
      }
      this.$dispatch("show-out-of-stock-button", false);
      return false;
    },
    getDeliveryTime() {
      fetch("/api/product/delivery-time/" + data.sku)
        .then((response) => response.json())
        .then((data) => {
          this.deliveryTime = data;
          if (data.error) {
            this.deliveryTimeError = true;
          }
          this.deliveryTimeLoading = false;
        })
        .catch((e) => {
          console.log(e);
          this.deliveryTimeError = true;
        });
    },
    showImageOverlayHanlder(id) {
      this.showImageOverlay = true;
      this.currentImageIndex = id;
    },
    constructUrl() {
      const url = new URL(window.location.origin + window.location.pathname);
      return url.toString() + "?" + this.constructSearchParams();
    },
    constructSearchParams() {
      const params = new URLSearchParams();
      params.set("id", this.selectedVariantID);
      const scrollTop = window.pageYOffset;
      if (scrollTop > 0) {
        params.set("scrollPos", String(scrollTop));
      }
      return params.toString();
    },
    async addToCart() {
      if (this.selectedVariantID) {
        this.addToCartLoading = true;
        const body = {
          variant_id: this.selectedVariantID,
          quantity: this.quantity,
        };
        if (this.isCustom) {
          body.customFields = this.customFields;
        }
        await this.$store.main.addToCart([body], true);
        this.addToCartLoading = false;
      }
    },
  }));
});
